export const coreBenefitsData = () => {
    return [
        {
          icon: 'benefits-15.svg',
          title: 'Early Access to Tickets',
          description: 'While it’s still uncertain when fans will return to Tropicana Field, Season Memberships ensure priority access when fans return to the stands.'
        },
        {
          icon: 'benefits-3.svg',
          title: 'Postseason Privileges',
          description: 'Season Members will have the opportunity to purchase Postseason tickets or Postseason ticket packages as determined by the Rays after the requirements of the Office of the Commissioner of Major League Baseball and the Rays organization have been met. Season Members will be notified of specific policies and procedures prior to any Postseason play.'
        },
        {
          icon: 'benefits-1.svg',
          title: 'Rays Rewards',
          description: 'A rewards program exclusively for Season Members to accrue points that may be redeemed toward can’t-buy experiences, merchandise, concessions, special access and much more!'
        },
        // {
        //   icon: 'benefits-2.svg',
        //   title: 'Republic Bank Draft Room',
        //   description: 'The Republic Bank Draft Room is an exclusive area for Season Members featuring daily entertainment including pregame player appearances, beer tastings, radio shows, local celebrities, alumni autograph sessions and more.'
        // },
        // {
        //   icon: 'benefits-4.svg',
        //   title: 'Special Events',
        //   description: 'Receive invitations to Season Member-only experiences and events. Past events have included player autograph sessions, Holiday Social, special access during Fan Fest and much more!'
        // },
        {
          icon: 'benefits-5.svg',
          title: 'Ticket Exchange Program',
          htmlDescription: 'Rays Season Members can return their tickets before a game has been played in exchange for credit toward other regular-season home game dates that better fit their schedule. <br /> <a href="https://www.mlb.com/rays/tickets/season-tickets/holders/future-game-exchanges" target="_blank">Full details</a>'
        },
        {
          icon: 'benefits-6.svg',
          title: 'Mobile Ticketing',
          description: 'The Ballpark app is your all-access pass to Tropicana Field! Enjoy access to mobile tickets, a 15% discount on concessions and merchandise, the opportunity to purchase discounted parking and more. Terms and conditions apply. Please note that print-at-home tickets are not available or accepted.'
        },
        {
          icon: 'benefits-7.svg',
          title: 'Personal Rays Representative',
          description: 'Contact your personal Rays representative with any questions throughout the season or to find out more about how to get the most out of your season membership.'
        },
        // {
        //   icon: 'benefits-8.svg',
        //   title: 'Exclusive Group & Suite Opportunities',
        //   description: 'Receive an added discount on group outings of 10 or more and qualify for complimentary catering when purchasing a suite for a game. Also, earn points through the Group Leader Rewards program.'
        // },
        {
          icon: 'benefits-9.svg',
          title: 'Complimentary subscription to 2021 MLB.tv yearly',
          description: 'Enjoy a complimentary subscription to MLB.tv! (2020 Value: $119.99). Watch every out-of-market game live or on demand in HD on your favorite supported mobile and connected device, featuring home or away feeds, DVR controls and more.'
        }
    ]
};

export const doubleBenefitsData = () => {
    return [
        {
          header: 'Full Season Members',
          icon: 'benefits-20.svg',
          title: 'Batting Practice Event at Tropicana Field',
          description:
            "Get in the batter's box at Tropicana Field or test your skills around the diamond! Take swings off a former Rays player, field groundballs and pop flies, and enjoy a fun-filled day at the ballpark. This event also includes photo opportunities, prizes and gifts and complimentary food and beverages."
        },
        {
          icon: 'benefits-21.svg',
            title: 'Catered Suite',
            description:
              'Entertain your friends, family, co-workers or clients in style in a suite for a regular season Rays home game! Complimentary food & beverage included. Game date and suite location are based on availability with some restrictions applying.'
        },
        {
          icon: 'benefits-12.svg',
            title: 'Rays Corporate Partner Gift Pack',
            description:
              'Enjoy a package of complimentary gift cards from a number of Rays Corporate Partner restaurants that are local to the Tampa Bay area, including Outback Steakhouse, Hunger + Thirst Group and more!'
        },
        {
          icon: 'benefits-15.svg',
            title: 'Rays Club Tickets',
            description:
              'Take in a 2020 Rays home game while lounging in the comfort of the Rays Club! Your complimentary ticket(s) to the Rays Club includes full access to buffets of upscale food items and an open bar, as well as enjoying a padded leather seat and drink service while watching the game. Game date and seat location based on availability with some restrictions applying.'
        },
        {
          header: 'All Season Members',
          icon: 'benefits-22.svg',
            title: 'Spring Training Experience',
            description:
              'Spend a day at Spring Training at Charlotte Sports Park and watch the Rays gear up for the 2020 season! This gift includes two tickets, one parking pass and concession credit to make your experience complete.'
        },
        {
          icon: 'benefits-23.svg',
            title: 'Rays Jersey',
            description:
              'Receive a special Rays merchandise item, one item per Double Play season ticket seat, as your special gift! Actual item is still to be determined. Past merchandise gift options have included a Rays replica jersey, Rays polo and long-sleeve pullover by Columbia Sportswear. More information will be provided at a later date.'
        },
        {
          icon: 'benefits-24.svg',
            title: 'Donation to the Rays Baseball Foundation',
            description:
              'Make a difference in the lives of thousands of children in the Tampa Bay area and have a donation made in your name to the Rays Baseball Foundation. Also join us for an on-field recognition celebration before a 2020 Rays home game.'
        }
    ]
};